import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { Refresh as RefreshIcon, RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import { Toastr } from 'data/common';
import { getRemotes } from '../../data/Remote/actions';

class Remote extends PureComponent {
    static propTypes = {
        initialized: PropTypes.bool.isRequired,
        getRemotes: PropTypes.func.isRequired,
        Remotes: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        const { initialized } = props;
        this.state = {
            loading: !initialized
        };
    }

    componentDidMount() {
        const { initialized } = this.props;
        if (!initialized) this.refreshRemotes();
    }

    /* NAVIGATION */
    navigateToDetail = rowData => {
        const { history } = this.props;
        // if (profile.get('admin') || profile.getIn(['user_rights', 'myfhe'], []).includes('RemoteDetails'))
        return history.push({ pathname: `Remote/detail/${rowData.id}` });
    };

    /* ACTIONS */
    refreshRemotes = () => {
        const { getRemotes } = this.props;
        this.setState({ loading: true });
        return getRemotes()
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    /* RENDER */
    renderActions = memoizeOne(profile => {
        const userRight = profile.getIn(['user_rights', 'myfhe'], []);

        let actions = {
            row: [],
            toolbar: [
                {
                    icon: RefreshIcon,
                    tooltip: Translator.translate('general.products.Remote.table.globalAction.refresh.tooltip'),
                    onClick: this.refreshRemotes
                }
            ]
        };
        if (profile.get('admin') || userRight.includes('RemoteDetails')) {
            actions.row.push({
                icon: ViewIcon,
                tooltip: Translator.translate('general.showDetail'),
                onClick: this.navigateToDetail
            });
        }
        return actions;
    });

    renderData = memoizeOne(Remotes => {
        let result = [];
        Remotes.map((Remote, RemoteId) => {
            result.push({
                id: parseInt(RemoteId),
                ref: Remote.get('ref'),
                brand: Remote.get('brand'),
                userEmail: Remote.get('userEmail'),
                tempMin: parseInt(Remote.get('tempMin')),
                tempMax: parseInt(Remote.get('tempMax')),
                ventilationMax: parseInt(Remote.get('ventilationMax'))
            });
        });
        return result;
    });
    renderColumns = memoizeOne(profile => {
        return [
            {
                title: Translator.translate('general.table.column.ref'),
                name: 'ref',
                action: (profile.get('admin') || profile.getIn(['user_rights', 'myfhe'], []).includes('remoteDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate('general.showDetail')
                }
            },
            {
                title: Translator.translate('general.table.column.brand'),
                name: 'brand'
            },
            { title: Translator.translate('general.table.column.email'), name: 'userEmail' },
            {
                title: Translator.translate('general.table.column.tempMin'),
                name: 'tempMin',
                render: (row, data, value) => {
                    if (!value) return null;
                    return <span>{value} °C</span>;
                }
            },
            {
                title: Translator.translate('general.table.column.tempMax'),
                name: 'tempMax',
                render: (row, data, value) => {
                    if (!value) return null;
                    return <span>{value} °C</span>;
                }
            },
            {
                title: Translator.translate('general.table.column.ventilationMax'),
                name: 'ventilationMax'
            }
        ];
    });
    render() {
        const { loading } = this.state;
        const { profile, Remotes } = this.props;

        return (
            <FHETable
                idTable="RemoteList"
                columns={this.renderColumns(profile)}
                data={this.renderData(Remotes)}
                actions={this.renderActions(profile)}
                title={Translator.translate('general.products.Remote.table.title')}
                emptyDataSourceMessage={Translator.translate('general.products.Remote.table.body.emptyDataSourceMessage')}
                isLoading={loading}
            />
        );
    }
}

function mapStateToProps(state) {
    const users = state.environments.myfhe.data.Users.get('list');
    let Remotes = state.environments.myfhe.data.Remote.get('list');
    Remotes = Remotes.map(Remote => {
        const masterId = Remote.getIn(['userMasterId'], '');
        return Remote.setIn(['userEmail'], users.getIn([masterId && masterId.toString(), 'email'], ''));
    });

    return {
        profile: state.data.user,
        Remotes,
        initialized: state.environments.myfhe.data.Remote.get('initialized')
    };
}
const styles = theme => ({
    connected: {
        color: theme.palette.success.main
    },
    disconnected: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getRemotes }, dispatch)
    )(withStyles(styles, { withTheme: true })(Remote))
);



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/Remote/index.js